import React, { useEffect } from "react";
import BuySell from "../shared/BuySell";
import Validate from "../shared/validation/Validate";

const SellingCurrency = () => {

    return (
        <Validate>
            <div className="">
                <div className="">
                    {/* <h1 className="text-headings text-3xl font-medium mt-10">Selling Currency</h1> */}
                    <BuySell payment={true} />
                </div>
            </div>
        </Validate>
    )
}

export default SellingCurrency;